import React from "react";
import { Shopify as ShopifyNew } from "./index.js";
import ShopifyOld from "../Shopify.js";
import { isNewShopifyFeatureAvailable } from "../../../../helpers/featureFlags.js";

const ShopifyIntegrationSelector = () => {
  return isNewShopifyFeatureAvailable() ? <ShopifyNew /> : <ShopifyOld />;
};

export default ShopifyIntegrationSelector;
